import { action, observable, runInAction, makeObservable } from 'mobx';

class AnimationStore {
  isLightAnimationByGameType = {};

  finishBlueLightningAnim = {};

  isRotateByGameType = {};

  isGameClosedByGameType = {};

  constructor() {
    makeObservable(this, {
      isGameClosedByGameType: observable.deep,
      isLightAnimationByGameType: observable.deep,
      finishBlueLightningAnim: observable.deep,
      isRotateByGameType: observable.deep,
      setIsRotateByGameType: action.bound,
      setLightningAnimationStart: action.bound,
      setFinishAnim: action.bound,
      setInitialAnimationState: action.bound,
      setToggleGameClosed: action.bound,
    });
  }

  setInitialAnimationState(roundAnimState, finishBlueLightningAnim, gameType) {
    this.isLightAnimationByGameType[gameType] = roundAnimState;
    this.isRotateByGameType[gameType] = roundAnimState;
    this.finishBlueLightningAnim[gameType] = finishBlueLightningAnim;
    this.isGameClosedByGameType[gameType] = false;
  }

  setLightningAnimationStart(bool, gameType) {
    this.isLightAnimationByGameType[gameType] = bool;
  }

  setFinishAnim(bool, gameType) {
    this.finishBlueLightningAnim[gameType] = bool;
  }

  setIsRotateByGameType(bool, gameType) {
    if (bool) {
      setTimeout(() => {
        runInAction(() => {
          this.isRotateByGameType[gameType] = bool;
        });
      }, 500);
    } else {
      this.isRotateByGameType[gameType] = bool;
    }
  }

  setToggleGameClosed(bool, gameType) {
    this.isGameClosedByGameType[gameType] = bool;
  }
}

export const animationStore = new AnimationStore();
